module.exports = __webpack_public_path__ + "img/banking-details.9aed1374.svg";